import { useEffect, useMemo } from 'react';

import { useShowConsumerBackerActivity, useShowConsumerBackerIntent } from '@givebacks/api/backer';
import { useForm } from '@givebacks/formy';
import { LoadingOverlay } from 'ui';

import { IntentSelection } from './IntentSelection';
import { ALL_ACTIVITY_OPTIONS } from './constants';
import { getAvailableActivityOptions } from './helperFunc';
import { IntentSelectionFormType, YourActivityFormValues } from './types';

const YourActivityIntent = () => {
  const { data: userActivityData, isFetching: isFetchingUserActivity } =
    useShowConsumerBackerActivity();
  const { data: userIntentData, isFetching: isFetchingUserIntent } = useShowConsumerBackerIntent();

  const availableActivityOptions = useMemo(
    () =>
      getAvailableActivityOptions({
        userActivity: userActivityData?.activity,
        allActivityOptions: ALL_ACTIVITY_OPTIONS,
      }),
    [userActivityData?.activity]
  );

  const yourActivityForm = useForm<YourActivityFormValues>(
    {
      initialValues: {},
      validate: {},
    },
    { id: 'yourActivityForm' }
  );

  useEffect(() => {
    if (userIntentData) {
      const initialValues = availableActivityOptions.reduce((acc, option) => {
        acc[option.key] = Boolean(userIntentData?.intent?.[option.key]);
        return acc;
      }, {} as IntentSelectionFormType);
      yourActivityForm.initialize(initialValues);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- Do not revaluate on support form
  }, [userIntentData, availableActivityOptions]);

  if (isFetchingUserIntent || isFetchingUserActivity) {
    return <LoadingOverlay visible={true} />;
  }

  return (
    <IntentSelection
      options={availableActivityOptions}
      title="Your Activity"
      getInputProps={yourActivityForm.getInputProps}
    />
  );
};

export { YourActivityIntent };
